export default {
  company: "Company address",
  main: "Main address",
  post: "Post address",
  invoice: "Invoice address",
}
